import { atom } from "jotai";

export type WebImageSelection = {
    url: string;
    mimeType: string;
};

export type WebImageChooserInfo = {
    onSelectImage: (uri?: WebImageSelection | null) => void | Promise<void>;
};

export const webImageChooser = atom<WebImageChooserInfo | null>(null);
